import { NumericFormat } from 'react-number-format'
import { getCurrency } from 'utils/authService'
import { timezoneDate } from 'utils/helpers'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import cn from 'classnames'
import s from './SpendItem.scss'

const SpendItem = ({ item, setEditedItem, toggleEditSpendItemtModal, deleteItem }) => {
  return (
    <div className={s.spendItemConatiner}>
      <div className={s.spendItem}>
        <span>
          <span className={s.time}>{timezoneDate(item.date)}</span> {item.name}
        </span>
        <span className={s.value}>
          <NumericFormat
            thousandSeparator
            allowNegative={false}
            value={item.value}
            prefix={getCurrency().symbol}
            displayType={'text'}
          />
        </span>
        <span className={s.createdByInfo}>
          {item.createdBy}
          <FaPencilAlt
            className={cn(s.editItem, s.itemAction)}
            onClick={() => {
              toggleEditSpendItemtModal()
              setEditedItem(item)
            }}
          />
          <FaTrashAlt
            className={cn(s.removeItem, s.itemAction)}
            onClick={() => deleteItem(item.id)}
          />
        </span>
      </div>
    </div>
  )
}

export default SpendItem
